
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/temp",
      function () {
        return require("private-next-pages/temp.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/temp"])
      });
    }
  